// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { TeamList } from 'types/TeamList';
import type { BlocContent } from 'types/NewsletterBloc';
import type { Status } from 'types/Status';
import type { CompetitionType } from 'types/Competitions';
import type { SeasonListType } from 'types/Seasons';
import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Sidebar from 'components/sidebar/Sidebar';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
import SubMenuHeader from 'components/header/SubMenuHeader';
import { teamSubmenuHeaders } from 'constants/menuConstants';
import { convertQueryStringToCompetitions, convertObjectToQueryString } from 'utils/urlUtils';
import CompetitionsFilters from 'components/competitions/CompetitionsFilters';
import ResultatListItem from 'components/competitions/ResultatListItem';
//import { parionsSportLink } from 'constants/parionsSportsConstant';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  title: string,
  excerpt: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: Array<BlocContent>,
  status: Status,
  currentSeasonId: number,
  competitions: Array<CompetitionType>,
  seasons: Array<SeasonListType>,
  defaultSeason: string,
  rencontres: Array<Object>,
  rencontresFetchStatus: Status,
  teamlist: Array<TeamList>,
  redirect_competitions: string,
  redirect_resultats: string
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  initialFetchCompetitions: (filters: Object) => void,
  fetchCompetitions: (filters: Object) => void,
  fetchSeason: () => void,
  InitialFetchRencontreByFilters: (filters: Object) => void,
  fetchRencontreByFilters: (filters: Object) => void,
  fetchTeamList: () => void
};

type Props = {
  match: any,
  history: any,
  location: any
} & DispatchProps &
  StateProps;

type State = {
  timestamp: any
};

class AllCompetitionsResults extends Component<Props, State> {
  unlisten: Function;
  state: State = {
    timestamp: ''
  };

  componentDidMount() {
    const filters = this.getFiltersOnQuery();
    const {
      initialFetchCompetitions,
      InitialFetchRencontreByFilters,
      fetchPageList,
      fetchTeamList,
      history,
      match: {
        params: { slug }
      }
    } = this.props;

    fetchPageList(slug);
    initialFetchCompetitions({ ...filters, equipe: slug });
    InitialFetchRencontreByFilters({ ...filters, equipe: slug });
    fetchTeamList();

    this.unlisten = history.listen(this._onRouteChange);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  _onRouteChange = (location: Object, action: string) => {
    const { search } = location;

    if (search !== '') {
      if (action !== 'REPLACE') {
        this._onChange();
      }
    }
  };

  _onChange = () => {
    const { fetchRencontreByFilters, fetchCompetitions } = this.props;
    const filters = this.getFiltersOnQuery();

    fetchCompetitions(filters);
    fetchRencontreByFilters(filters);
  };

  onFilterChange = filters => {
    const { history, fetchRencontreByFilters, fetchCompetitions } = this.props;
    history.replace({
      search: convertObjectToQueryString(filters)
    });
    fetchCompetitions(filters);
    fetchRencontreByFilters(filters);
  };

  getFiltersOnQuery = () => {
    const {
      location: { search },
      seasons,
      match: {
        params: { slug }
      },
      currentSeasonId
    } = this.props;
    const todayString = new Date()
      .toLocaleString('fr')
      .substr(0, 10)
      .split('/')
      .reverse()
      .join('-');

    if (search !== '') {
      return convertQueryStringToCompetitions(search);
    } else {
      const currentSeason =
        seasons && seasons.length > 1
          ? seasons.some(season => season.id === currentSeasonId)
            ? currentSeasonId
            : seasons[seasons.length - 1].id
          : null;
      return { equipe: slug, season: currentSeason, end_date: todayString };
    }
  };

  renderMatchs = () => {
    const { rencontres, title, rencontresFetchStatus } = this.props;
    if (rencontresFetchStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }
    return rencontres.map((rencontre, index) => {
      const {
        competition: { name },
        meta: { date_rencontre },
        id,
        link
      } = rencontre;
      const rencontreData = rencontre.meta;
      const competitionTitle = index !== 0 && name === rencontres[index - 1].competition.name ? '' : name;
      const spaceTitle = !!(index !== 0 && name !== rencontres[index - 1].competition.name);
      return (
        <ResultatListItem
          key={id}
          rencontres={[{ ...rencontreData, date_rencontre: date_rencontre, link }]}
          equipeNom={title}
          title={competitionTitle}
          spaceTitle={spaceTitle}
        />
      );
    });
  };

  teamChange(team: Object) {
    this.props.history.push(team.link);
  }

  render() {
    const {
      title,
      excerpt,
      status,
      featured_media,
      sidebar_content,
      seasons,
      defaultSeason,
      competitions,
      teamlist,
      redirect_resultats
    } = this.props;
    const { typeRugby, slug } = this.props.match.params;
    const seasonsResultats = seasons.filter(season => season.resultats === true);
    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }
    if (redirect_resultats) {
      window.location = redirect_resultats;
    }
    let selectedTeam = false;
    if (teamlist && teamlist.length > 0) {
      selectedTeam = teamlist.filter((team, index) => {
        return team.title === title;
      });
    }

    if (this.props.match.params.slug === 'xv-de-france') {
      teamSubmenuHeaders[7] = {
        menu_order: 35,
        object_slug: '/le-grand-soutien',
        title: 'Le grand soutien',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }

    /*if (this.props.match.params.slug === 'xv-de-france-masculin') {
      teamSubmenuHeaders[7] = {
        menu_order: 40,
        object_slug: parionsSportLink,
        title: 'Parions Sport',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }*/

    return (
      <>
        <section className="banner">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: typeRugby.replace(/-/g, ' '), to: '/equipe-de-france/' + typeRugby },
                { name: title, to: '/equipe-de-france/' + typeRugby + '/' + slug },
                `L'équipe`
              ]}
              isDark
            />
            {teamlist && teamlist.length > 0 && selectedTeam && selectedTeam.length > 0 && (
              <TeamMenuDropdownMenu
                hiddenMenuElements={teamlist}
                isMobile={false}
                id={6}
                level={'h1'}
                activeTeam={selectedTeam[0]}
                switchTeam={this.teamChange.bind(this)}
              />
            )}
            {(!teamlist || teamlist.length === 0) && <h1 className="ft-h2">{title}</h1>}
            {excerpt && <p className="banner__desc">{excerpt}</p>}
          </div>
          <SubMenuHeader
            subMenus={teamSubmenuHeaders}
            subMenuPath={'/equipe-de-france/' + typeRugby + '/' + slug}
            status={STATUS_SUCCESS}
            niveauMenu={4}
          />
        </section>

        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                {!redirect_resultats && seasonsResultats.length > 0 && (
                  <CompetitionsFilters
                    defaultSeason={defaultSeason}
                    competitions={competitions}
                    slug={slug}
                    seasons={seasonsResultats}
                    onFilterChange={filters => this.onFilterChange(filters)}
                    initialFilters={this.getFiltersOnQuery()}
                  />
                )}
                <div className="row">
                  <div className="col col-lg-8on9">
                    <div className="block-competition mb-md-4 mb-lg-0">
                      {!redirect_resultats && this.renderMatchs()}
                      {redirect_resultats && (
                        <div className="row">
                          <div className="col col-lg-8on9 mt-3">
                            <p>Redirection</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(withRouter(AllCompetitionsResults))((Helmet, pageProps) => {
  const {
    title,
    match: { params, url }
  } = pageProps;
  const ogimage = pageProps.featured_media ? pageProps.featured_media.src : false;
  const ogimagetitle = pageProps.featured_media ? pageProps.featured_media.title : false;
  const meta = getMetaBySlug(url, params);

  return (
    <Helmet>
      <title>{meta.title(title)}</title>
      <meta name={'description'} content={meta.description(title)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(title)} />
      <meta property={'og:description'} content={meta.description(title)} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
